exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".custom-file--renew-certificate {\r\n    height: 42px;\r\n}\r\n\r\n    .custom-file--renew-certificate .inputfile {\r\n        width: 0.1px;\r\n        height: 0.1px;\r\n        opacity: 0;\r\n        overflow: hidden;\r\n        position: absolute;\r\n        z-index: -1;\r\n    }\r\n\r\n    .custom-file--renew-certificate .custom-file-label {\r\n        content: attr(data-label);\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n    }\r\n\r\n    html:not([dir=\"rtl\"]) .custom-file--renew-certificate .custom-file-label {\r\n        padding-right: 9rem;\r\n    }\r\n\r\n    [dir=\"rtl\"] .custom-file--renew-certificate .custom-file-label {\r\n        padding-left: 9rem;\r\n    }\r\n\r\n        .custom-file--renew-certificate .custom-file-label::after {\r\n            height: calc(42px - 4px);\r\n            line-height: 2;\r\n        }\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/styles/certificates/certificateRenewalForm.component.css
// module id = 444
// module chunks = 0